package pt.at.oss.kotlin.manual.validator.common

import pt.at.oss.kotlin.manual.enumeration.CustomErrorCodes
import pt.lightweightform.kotlin.type.validator.ValidationCodes
import pt.lightweightform.kotlin.type.validator.ValidationError

/**
 * Created by Pedro Alfaiate on 15/05/2020.
 */

fun validateRequiredStrIf(value: String?, isRequired: Boolean): ValidationError? {
    return if (isRequired && value.isNullOrBlank()) ValidationError(ValidationCodes.LF_IS_REQUIRED)
    else null
}

fun validateRequiredBoolIf(value: Boolean?, isRequired: Boolean): ValidationError? {
    return if (isRequired && value == null) ValidationError(ValidationCodes.LF_IS_REQUIRED)
    else null
}

fun <T> validateAllowedValues(value: T, allowedValues: Collection<T>): ValidationError? {
    return if (!allowedValues.contains(value)) ValidationError(ValidationCodes.UNALLOWED_VALUE_CODE)
    else null
}

fun validateAllowedIf(value: String?, isAllowed: Boolean): ValidationError? {
    return if (!isAllowed && !value.isNullOrBlank()) ValidationError(ValidationCodes.UNALLOWED_VALUE_CODE)
    else null
}

fun validateCollapsedSpace(value: String?): ValidationError? {
    val ifFilledThenNoConsecutiveSpaces =
        !value.isNullOrEmpty() && value.replace("\\s+".toRegex(), " ").length != value.length
    return if (ifFilledThenNoConsecutiveSpaces) ValidationError(CustomErrorCodes.ONLY_SINGLE_SPACES_ALLOWED.code)
    else null
}
